declare global { interface Window { dataLayer: any; } }
const dataLayer = window.dataLayer || [];

export default dataLayer;